import { scrollWindow, resizeWindow } from './eventsWindow';
import { socialShare } from './analytics';
import { openTeamsMenu, chooseTeamInMenu } from './components/main-tabs';
import {
  transactionDetails,
  transactionCollapse,
  transactionUserVote,
  viewMoreTransactions,
} from './components/homeTransaction';
import { viewMoreTeamTransactions } from './components/teamTransactions';
import { buildStatisticsPage, showTeamsList, showTeamStatistics } from './components/statistics';

/**
 * @param {Object} event Event object
 */
function onKeyUp(event) {
  const isEsc = event.keyCode === 27;

  if (isEsc) {
    $('.choose-team-list').removeClass('active');
    $('.statistics-by-team-list-teams-container .teams-list-menu').removeClass('active');
  }
}

/**
 * @param {Object} event Event object
 */
function onDocumentClick(event) {
  const isTeamList = $(event.target).hasClass('choose-team-list');
  const isTeamListChildren = $(event.target).closest('.choose-team-list').length;
  const isChooseTeamContainer = $(event.target).hasClass('choose-team-container');

  if (!isTeamList && !isTeamListChildren && !isChooseTeamContainer) {
    $('.choose-team-list').removeClass('active');
  }

  const isStatisticsTeamList = $(event.target).hasClass('statistics-by-team-list-teams-container');
  const isStatisticsTeamListChildren = $(event.target).closest('.statistics-by-team-list-teams-container').length;

  if (!isStatisticsTeamList && !isStatisticsTeamListChildren) {
    $('.statistics-by-team-list-teams-container .teams-list-menu').removeClass('active');
  }
}

/**
 *
 */
export default function bindEvents() {
  $(window).on('scroll', scrollWindow).on('resize', resizeWindow);
  $(document).on('keyup', onKeyUp);
  $(document).on('click', onDocumentClick);
  $(document).on('click', '.teams-list .escudo', chooseTeamInMenu);
  $('.social-icons-icon').on('click', socialShare);
  $(document).on('click', '.transaction-row-container .visible-content', transactionDetails);
  $(document).on('click', '.transaction-row-container .close-collapsed-content', transactionCollapse);
  $(document).on('click', '.transaction-row-container .single-feedback', transactionUserVote);
  $(document).on('click', '.view-more-team-transactions', viewMoreTeamTransactions);
  $('.view-more-transactions').on('click', viewMoreTransactions);
  $('.choose-team-container').on('click', openTeamsMenu);
  $('.single-tab-statistics').on('click', buildStatisticsPage);

  $('.statistics-by-team-list-teams').on('click', showTeamsList);
  $(document).on('click', '.teams-list-menu .escudo', showTeamStatistics);
}



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/events.js